import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=4e3c554a&"
import script from "./CampaignStats.vue?vue&type=script&lang=ts&"
export * from "./CampaignStats.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports